import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenStorageService } from 'services/token/token-storage.service';
import { ProfileService } from 'services/profile/profile.service';
import _get from 'lodash-es/get';
import { UserService } from 'services/user/user.service';
import { UserProfile } from 'services/user/user.interface';
import { DomainService } from 'services/domain/domain.service';
import { SmartModalService } from '@certemy/ui-components';
import { CHANGE_DOMAIN_TYPE } from 'constants/constants';

@Injectable()
export class AlreadyLoggedGuardService  {
  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private profileService: ProfileService,
    private userService: UserService,
    private domainService: DomainService,
    private smartModalService: SmartModalService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const profile = this.profileService.profile as UserProfile;
    const role_id = _get(profile, 'role_id');
    const latestSessionUrl = _get(profile, 'latestSessionUrl');
    const changeDomainTypeStr = this.domainService.getTokenFromCookies('changeDomainType');
    const changeDomainType = changeDomainTypeStr && Number(changeDomainTypeStr);
    this.domainService.removeTokenFromCookies('changeDomainType');
    if (this.tokenStorageService.isLoggedIn && role_id) {
      const redirectLink = this.userService.generateRedirectLink('', {
        ...profile,
        role_id,
        latestSessionUrl: changeDomainType ? latestSessionUrl : null,
      });
      this.router.navigate(redirectLink.link, { queryParams: redirectLink.queryParams }).then(() => {
        if (changeDomainType === CHANGE_DOMAIN_TYPE.IS_RENEW) {
          setTimeout(
            () =>
              this.smartModalService
                .openNotification({
                  title: 'Notification',
                  body: `You currently have an active session in a different browser window.
            We have switched you to the profile you are using in the other browser window
             as you may only have 1 active user session at a time.`,
                })
                .subscribe(),
            1000,
          );
        }
      });
      return false;
    } else {
      this.tokenStorageService.dropAllTokens();
      return true;
    }
  }
}

export const alreadyLoggedGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(AlreadyLoggedGuardService).canActivate(route, state);
};
